
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Link } from "react-router-dom";

const InquiriesTab = () => {
  const inquiries = [
    { name: "John Smith", property: "Seaside Luxury Villa", date: "Today, 2:30 PM", status: "New" },
    { name: "Sarah Johnson", property: "Downtown Apartment", date: "Yesterday", status: "Responded" },
    { name: "Michael Brown", property: "Mountain Retreat", date: "Sep 24, 2023", status: "Scheduled" },
    { name: "Emma Wilson", property: "Seaside Luxury Villa", date: "Sep 23, 2023", status: "Responded" },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle>Recent Inquiries</CardTitle>
        <CardDescription>The latest inquiries for your properties</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {inquiries.map((inquiry, i) => (
            <div key={i} className="flex items-start justify-between pb-4 last:pb-0 border-b last:border-0">
              <div>
                <div className="font-medium">{inquiry.name}</div>
                <div className="text-sm text-muted-foreground">{inquiry.property}</div>
                <div className="text-xs text-muted-foreground">{inquiry.date}</div>
              </div>
              <Badge variant={
                inquiry.status === "New" ? "default" : 
                inquiry.status === "Responded" ? "outline" : 
                "secondary"
              }>
                {inquiry.status}
              </Badge>
            </div>
          ))}
        </div>
      </CardContent>
      <CardFooter>
        <Button variant="outline" className="w-full" asChild>
          <Link to="/dashboard/inquiries">
            View All Inquiries
          </Link>
        </Button>
      </CardFooter>
    </Card>
  );
};

export default InquiriesTab;
